export class Research{
    researchId: number;
    researchName: string;
}
export class GroupsToBeMoved{
    researchArea: number;
    listOfGroups: number[];
}
